import React, { Component, Fragment } from "react";
import SearchHeader from "./searchHeader";
import Notification from "./notification";
import User_menu from "./user-menu";
import Language from "./language";
import { Maximize2, Bell, MessageSquare, MoreHorizontal, Menu, Sun, Moon } from "react-feather";
import { connect } from "react-redux";
import "./header.css";

import logo from "../../../assets/images/brand/kido-logo.png";

export class Header extends Component {
  constructor(props) {
    super(props);
    this.state = {
      sidebar: true,
      rightSidebar: true,
      navMenus: false,
    };
  }

  toggle() {
    this.setState((prevState) => ({
      navMenus: !prevState.navMenus,
    }));
  }

  showRightSidebar = () => {
    if (this.state.rightSidebar) {
      this.setState({ rightSidebar: false });
      document.querySelector(".right-sidebar").classList.add("show");
    } else {
      this.setState({ rightSidebar: true });
      document.querySelector(".right-sidebar").classList.remove("show");
    }
  };

  goFull = () => {
    if (
      (document.fullScreenElement && document.fullScreenElement !== null) ||
      (!document.mozFullScreen && !document.webkitIsFullScreen)
    ) {
      if (document.documentElement.requestFullScreen) {
        document.documentElement.requestFullScreen();
      } else if (document.documentElement.mozRequestFullScreen) {
        document.documentElement.mozRequestFullScreen();
      } else if (document.documentElement.webkitRequestFullScreen) {
        document.documentElement.webkitRequestFullScreen(Element.ALLOW_KEYBOARD_INPUT);
      }
    } else {
      if (document.cancelFullScreen) {
        document.cancelFullScreen();
      } else if (document.mozCancelFullScreen) {
        document.mozCancelFullScreen();
      } else if (document.webkitCancelFullScreen) {
        document.webkitCancelFullScreen();
      }
    }
  };

  openCloseSidebar = () => {
    if (this.state.sidebar) {
      this.setState({ sidebar: false });
      document.querySelector(".page-main-header").classList.add("open");
      document.querySelector(".page-sidebar").classList.add("open");
    } else {
      this.setState({ sidebar: true });
      document.querySelector(".page-main-header").classList.remove("open");
      document.querySelector(".page-sidebar").classList.remove("open");
    }
  };

  render() {
    var totalNotifacationCount = "";
    if (this.props.pendingOrders && this.props.unverifiedPayments) {
      totalNotifacationCount +=
        this.props.pendingOrders.length + this.props.unverifiedPayments.length;
    }
    const hasNotifications = Number(totalNotifacationCount) > 0;
    const hour = new Date().getHours();
    const isDay = hour >= 6 && hour < 18;
    const today = new Date().toLocaleDateString("en-GB", {
      weekday: "short",
      day: "numeric",
      month: "short",
    });

    return (
      <Fragment>
        <div className="page-main-header kd-header">
          <div className="main-header-right row">

            {/* Mobile logo */}
            <div className="main-header-left d-lg-none">
              <div className="logo-wrapper">
                <a href="/dashboard">
                  <img className="kd-header-logo" src={logo} alt="KIDO, where dreams begin" />
                </a>
              </div>
            </div>

            {/* Sidebar toggle + today */}
            <div className="mobile-sidebar kd-header-start">
              <button
                type="button"
                className="hdr-toggle"
                aria-label="Toggle menu"
                onClick={this.openCloseSidebar}
              >
                <Menu size={18} />
              </button>
              <span className="kd-header-day">
                {isDay ? <Sun size={15} /> : <Moon size={15} />}
                {today}
              </span>
            </div>

            {/* Right nav */}
            <div className="nav-right col">
              <ul className={"nav-menus " + (this.state.navMenus ? "open" : "")}>

                <li className="kd-nav-search">
                  <SearchHeader />
                </li>

                <li>
                  <a
                    onClick={this.goFull}
                    className="hdr-icon-btn"
                    href="#!"
                    aria-label="Full screen"
                    title="Full screen"
                  >
                    <Maximize2 size={18} />
                  </a>
                </li>

                <li className="onhover-dropdown">
                  <a className="hdr-icon-btn hdr-lang" href="#" aria-label="Language">
                    EN
                  </a>
                  <Language />
                </li>

                <li className="onhover-dropdown">
                  <a className="hdr-icon-btn" href="#" aria-label="Notifications">
                    <Bell size={18} className={hasNotifications ? "kd-bell-ring" : ""} />
                    {hasNotifications && (
                      <span className="kd-count">{totalNotifacationCount}</span>
                    )}
                  </a>
                  <Notification totalNotificationCount={totalNotifacationCount} />
                </li>

                <li>
                  <a
                    className="hdr-icon-btn"
                    onClick={this.showRightSidebar}
                    href="#"
                    aria-label="Messages"
                    title="Messages"
                  >
                    <MessageSquare size={18} />
                  </a>
                </li>

                <User_menu />
              </ul>

              <div
                className="d-lg-none mobile-toggle pull-right"
                onClick={() => this.toggle()}
              >
                <MoreHorizontal />
              </div>
            </div>
          </div>
        </div>
      </Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  const unVerifiedPaymentsArray = [];
  state.payments.payments.forEach((payment) => {
    payment.payments.forEach((inPayment) => {
      if (inPayment.paymentStatus === "unVerified") {
        unVerifiedPaymentsArray.push(inPayment);
      }
    });
  });
  return {
    pendingOrders: state.orders.orders.filter(
      (order) => order.status === "order_pending"
    ),
    unverifiedPayments: unVerifiedPaymentsArray,
  };
};

export default connect(mapStateToProps)(Header);
